module.exports = __webpack_public_path__ + "static/btn06-2e8c31a409f9e7e549e70afadf88af24.png";